import React, { useState } from "react";
import { Link } from "react-router-dom";
import { baseUrl } from "../UrlHelper/baseUrl";

const Contact = () => {
  const [result, setResult] = useState("");
  const [success, setSuccess] = useState(false);

const onSubmit = async (event) => {
  event.preventDefault();
  setResult("Sending...");
  setSuccess(false);

  const formData = new FormData(event.target);
  const data = {
    name: formData.get("name"),
    email: formData.get("email"),
    mobile: formData.get("mobile"),
    message: formData.get("message"),
  };

  try {
    const response = await fetch(`${baseUrl}/contact`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    const resData = await response.json();

    if (resData.success) {
      setResult("Form Submitted Successfully");
      setSuccess(true);
      event.target.reset();
    } else {
      setResult(resData.message || "Something went wrong");
    }
  } catch (error) {
    console.error(error);
    setResult("Failed to send. Please try again.");
  }
};
  return (
    <>
      {/* <div>
        <nav className=" navbar-expand-lg bg-body-tertiary">
          <div className="container-fluid">
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav" style={{ gap: 8 }}>
                <li className="nav-item">
                  <Link
                    to="/"
                    className="nav-link active"
                    aria-current="page"
                    style={{ fontSize: "15", color: "blue" }}
                  >
                    Home/
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/contact"
                    className="nav-link active"
                    aria-current="page"
                    style={{ fontSize: 15 }}
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div> */}

      <section className="container mt-3 mb-5">
        <div className="row">
          <div className="col-sm-12 mb-4 col-md-5">
            <div className="card border-black rounded-0">
              <div className="card-header p-0">
                <div className="bg-black text-white text-center py-2">
                  <h3>
                    <i className="fa fa-envelope" /> Write to us:
                  </h3>
                  <p className="m-0">
                    We’ll write rarely, but only the best content.
                  </p>
                </div>
              </div>
              <div className="card-body p-3">
                <form onSubmit={onSubmit}>
                  <div className="form-group mb-4">
                    <label className="mb-2"> Your name </label>
                    <input
                      type="text"
                      name="name"
                      required
                      className="form-control"
                      placeholder="Your name"
                    />
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">Your email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      required
                      placeholder="Email"
                    />
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">Mobile No.</label>
                    <input
                      type="text"
                      className="form-control"
                      name="mobile"
                      required
                      placeholder="Mobile No"
                    />
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">Message</label>
                    <textarea
                      className="form-control"
                      name="message"
                      required
                      placeholder="Write your message"
                    ></textarea>
                  </div>

                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn btn-block rounded-0 py-2"
                      style={{ backgroundColor: "black", color: "white" }}
                    >
                      Submit
                    </button>
                  </div>
                </form>

                {/* ✅ Success/Failure Message */}
                {result && (
                  <div className="text-center mt-3">
                    {success ? (
                      <div style={{ color: "green", fontSize: "18px" }}>
                        ✅ {result}
                      </div>
                    ) : (
                      <div style={{ color: "LIGHTGREEN", fontSize: "16px" }}>
                         {result}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Map + Contact Info */}
          <div className="col-sm-12 col-md-7">
         <div className="mb-4">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3680.3322314896037!2d75.86473407528746!3d22.7114427793818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962fcbf0e556aa9%3A0x4a649de7ff2c1e4d!2sKiaan%20Technology!5e0!3m2!1sen!2sin!4v1733306031092!5m2!1sen!2sin"
            width="100%" height={450} frameBorder={0} style={{ border: 0 }} allowFullScreen="" aria-hidden="false"  tabIndex={0}/>
            </div>
            <div className="row text-center">
              <div className="col-md-4">
                <a className="bg-black px-3 py-2 rounded text-white mb-2 d-inline-block">
                  <i className="fa fa-map-marker" />
                </a>
                <p>
                  Address: City: Guwahati Dist: Kamrup State: Assam Landmark:
                  Kamakhya temple Pin: 781010
                </p>
              </div>
              {/* <div className="col-md-4">
                <a
                  href="tel:+91-86389094798"
                  className="bg-black px-3 py-2 rounded text-white mb-2 d-inline-block"
                >
                  <i className="fa fa-phone" />
                </a>
                <a href="tel:+91-86389094798">
                  <p>+91-86389094798</p>
                </a>
              </div> */}
              <div className="col-md-4">
                <a className="bg-black px-3 py-2 rounded text-white mb-2 d-inline-block">
                  <i className="fa fa-envelope" />
                </a>
                <p>maakamakhyapujaseva@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
